import React from 'react';
import { StepperMeta, StepperSegment, StepperSegments } from './styles';

type Props = {
  steps: string[];
  /** Index into steps. */
  current: number;
};

const PonderStepper = ({ steps, current }: Props) => (
  <div>
    <StepperSegments aria-hidden>
      {steps.map((step, index) => (
        <StepperSegment
          key={step}
          state={index < current ? 'done' : index === current ? 'current' : 'todo'}
        />
      ))}
    </StepperSegments>
    <StepperMeta>
      <span>{steps[current]}</span>
      <span>
        {current + 1} of {steps.length}
      </span>
    </StepperMeta>
  </div>
);

export default PonderStepper;
